import React from 'react';
import { IonSearchbar, IonSelect, IonSelectOption, IonItem, IonGrid, IonRow, IonCol } from '@ionic/react';
import { Game, CardFilters } from '../types';

interface Props {
  filters: CardFilters;
  games: Game[];
  onFilterChange: (filters: Partial<CardFilters>) => void;
}

const SearchFilterBar: React.FC<Props> = ({ filters, games, onFilterChange }) => {
  const selectedGame = games.find((g) => g.id === filters.game_id);

  return (
    <div>
      <IonSearchbar
        value={filters.search || ''}
        onIonInput={(e) => onFilterChange({ search: e.detail.value || '', page: 1 })}
        placeholder="Search cards..."
        debounce={300}
      />
      <IonGrid>
        <IonRow>
          <IonCol size="6">
            <IonItem>
              <IonSelect
                label="Game"
                labelPlacement="stacked"
                value={filters.game_id || null}
                onIonChange={(e) => onFilterChange({ game_id: e.detail.value || undefined, page: 1 })}
                interface="popover"
                placeholder="All Games"
              >
                <IonSelectOption value={null}>All Games</IonSelectOption>
                {games.map((g) => (
                  <IonSelectOption key={g.id} value={g.id}>{g.name}</IonSelectOption>
                ))}
              </IonSelect>
            </IonItem>
          </IonCol>
          <IonCol size="6">
            <IonItem>
              <IonSelect
                label="Rarity"
                labelPlacement="stacked"
                value={filters.rarity || null}
                onIonChange={(e) => onFilterChange({ rarity: e.detail.value || undefined, page: 1 })}
                interface="popover"
                placeholder="All Rarities"
              >
                <IonSelectOption value={null}>All Rarities</IonSelectOption>
                {selectedGame?.rarity_options.map((r) => (
                  <IonSelectOption key={r} value={r}>{r}</IonSelectOption>
                ))}
              </IonSelect>
            </IonItem>
          </IonCol>
        </IonRow>
      </IonGrid>
    </div>
  );
};

export default SearchFilterBar;
